module.exports = __webpack_public_path__ + "img/whatsapp-menu.cf9dd0e5.svg";